<template>
  <div :class="{ 'has-empty-state': !activities.length }">
    <div v-if="activities.length" id="al-activity-notification">
      <single-notification
        v-for="notification in activities.slice(0, limit)"
        :key="notification._id"
        :notification="notification"
        @viewedNotification="viewNotification(notification.link, notification._id)"
      />
    </div>
    <NotificationEmptyState v-else name="Notifications" />
  </div>
</template>

<script>
import SingleNotification from './SingleNotification.vue';
import NotificationEmptyState from './NotificationEmptyState.vue';

/**
 * Simple list of notifications with empty state when activities array is empty.
 * @displayName activity-notification
 */

export default {
  components: {
    SingleNotification,
    NotificationEmptyState
  },

  props: {
    /**
     * Max number of notification to render.
     */
    limit: {
      type: Number,
      default: 10
    },
    /**
     * Array of javascript object with notification data. To know what structure
     * is needed view [SingleNotification](/#/modules?id=singlenotification)
     */
    activities: {
      type: Array,
      required: true
    }
  },
  methods: {
    viewNotification(link, notificationID) {
      /**
       * Event emitting when user clicks in some internal notification.
       * @property {String} notificationId Id of activity clicked
       */
      this.$emit('viewNotification', notificationID);
      this.$router.push(link);
    }
  }
};
</script>

<style>
.has-empty-state {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
}
</style>
